export const REQUIRED_CONVERSATION_CAPABILITY_KEYS = [
  "canTakeover",
  "canSchedule",
  "canStop",
  "showSessionMeta",
  "showSupervisorControlMessages",
  "operatorView",
];

function boolWithDefault(value, defaultValue) {
  return typeof value === "boolean" ? value : defaultValue;
}

export function assertConversationCapabilities(capabilities, contextName) {
  if (import.meta.env.PROD) return;
  if (!capabilities || typeof capabilities !== "object") {
    throw new Error(
      `[${contextName}] capabilities object is required for ConversationWorkspace`
    );
  }
  const missing = REQUIRED_CONVERSATION_CAPABILITY_KEYS.filter(
    (key) => typeof capabilities[key] !== "boolean"
  );
  if (missing.length > 0) {
    throw new Error(
      `[${contextName}] missing required capability booleans: ${missing.join(
        ", "
      )}`
    );
  }
}

export function applyCapabilitiesToChatUiPolicy(chatUiPolicy, capabilities) {
  return {
    ...(chatUiPolicy || {}),
    showSessionOperationalMetaInChat: capabilities.showSessionMeta,
    showSupervisorControlMessagesInChat:
      capabilities.showSupervisorControlMessages,
    enableHumanTakeoverMode: capabilities.canTakeover,
  };
}

export function buildAgentSessionCapabilities(chatUiPolicy, isPublicMode) {
  const isPublic = isPublicMode === true;
  return {
    canTakeover:
      !isPublic && chatUiPolicy?.enableHumanTakeoverMode === true,
    canSchedule: !isPublic,
    canStop: !isPublic,
    showSessionMeta:
      chatUiPolicy?.showSessionOperationalMetaInChat !== false,
    showSupervisorControlMessages:
      chatUiPolicy?.showSupervisorControlMessagesInChat !== false,
    operatorView: !isPublic,
  };
}

function normalizeThreadStatus(status, executionInProgress) {
  if (executionInProgress === true) return "IN_PROGRESS";
  const normalized = String(status || "")
    .trim()
    .toUpperCase();
  if (!normalized) return "IN_PROGRESS";
  if (normalized === "DONE" || normalized === "OPEN" || normalized === "NO_MENTIONED_AGENTS")
    return "COMPLETED";
  if (normalized === "FAILED") return "ERROR";
  if (normalized === "WAITING" || normalized === "RUNNING_AGENTS")
    return "IN_PROGRESS";
  return normalized;
}

export function buildChannelThreadConversationSession(
  threadDetail,
  executionInProgress
) {
  if (!threadDetail) return null;
  return {
    ...threadDetail,
    chatSessionId: threadDetail.threadId || "",
    title: threadDetail.title || threadDetail.rootMessage || "Thread",
    status: normalizeThreadStatus(threadDetail.status, executionInProgress),
    messages: Array.isArray(threadDetail.messages) ? threadDetail.messages : [],
  };
}

export function buildChannelThreadCapabilities(overrides = {}) {
  return {
    canTakeover: boolWithDefault(overrides.canTakeover, false),
    canSchedule: boolWithDefault(overrides.canSchedule, true),
    canStop: boolWithDefault(overrides.canStop, true),
    showSessionMeta: boolWithDefault(overrides.showSessionMeta, true),
    showSupervisorControlMessages: boolWithDefault(
      overrides.showSupervisorControlMessages,
      true
    ),
    operatorView: boolWithDefault(overrides.operatorView, true),
  };
}
